import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams,useLocation, useNavigate } from "react-router-dom";
import { getRegistration, getRegisterUser, message, register, getSubsite } from '../reducers/auth';
import * as Yup from 'yup';
import { Formik } from 'formik';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import AuthService from "../services/auth.service";

const Register = () => {
  let navigate = useNavigate();
  const form = useRef();
  const checkBtn = useRef();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [successful, setSuccessful] = useState(false);
  const theMessage = useSelector(message);
  const [registerUser, setRegisterUser] = useState({});
  let [searchParams, setSearchParams] = useSearchParams();
  const currentSubsite = useSelector(getSubsite);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  const location = useLocation();
  
  useEffect(() => {
    setLoading(true);
    async function fetchData(setError) {
      const response = await AuthService.getRegistration(searchParams.get("id"));
      if(response.error) {
        console.log("ERROR", response.message);
        setError(response.message)
      } else {
        
        setRegisterUser(response.user);
        setError("");

      }
      setLoading(false);
    }
    fetchData(setError);
  }, [searchParams]);

  const registerValidationSchema = Yup.object().shape({
    street1: Yup.string()
      .required("*Street is required"),
    city: Yup.string()
      .required("*City is required"),
    state: Yup.string()
      .required("*State is required"),
    zip: Yup.string()
      .required("*Zip Code is required")
      .min(5, "*Zip Code must be at least 5 digits")
      .max(10, "*Zip Code can't be more than 10 digits"),
    password: Yup.string()
      .required('No password provided.') 
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"),
    passwordConfirmation: Yup.string()
     .required('No password confirmation provided.') 
     .oneOf([Yup.ref('password'), null], 'Passwords must match')
  });



  return (
    <div className="container">
      {error && !loading && (
        <div className="alert alert-danger" role="alert">
          {error}
          </div>
      )}
      {!error && !loading && (
      <div style={{marginBottom: 70}}>

          <p>Welcome to Ignite Gear.  To finish your registration, enter your shipping address below and set your password.  After registration, you will be asked to login with your new password.</p>
        {searchParams.get("id") && (<>
        <p>User Id: <strong>{registerUser && (registerUser.email)}</strong></p>
        <p>Email: <strong>{registerUser && (registerUser.email)}</strong></p>
        <p>Name: <strong>{registerUser && (registerUser.firstname + " " + registerUser.lastname)}</strong></p>
        </>
        )}
        {!searchParams.get("id") && (
        <p>You are registering for the <strong>{currentSubsite.subsiteName}</strong> apparel site.</p>
        )}
        <Formik 
        initialValues={{ firstName: registerUser.firstname, lastName: registerUser.lastname, email: registerUser.email, street1:"", street2:"", city:"", state:"", zip:"", password: "", passwordConfirmation: ""}}
        validationSchema={registerValidationSchema}
        onSubmit={(values, {setSubmitting, resetForm}) => {
          // When button submits form and form is in the process of submitting, submit button is disabled
          console.log("FORM VALUES", values);
          setSubmitting(true);
          values.regid = searchParams.get("id");
          values.subsiteId = currentSubsite.id;
          dispatch(register(values));
          setSubmitting(false);
          if(values.regid) {
            navigate("/confirmreg");
          } else {
            navigate("/confirmnewreg");
          }

      }}
        >
        {/* Callback function containing Formik state and helpers that handle common form actions */}
          {( {values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting }) => (
            <Form onSubmit={handleSubmit} >
                 {!searchParams.get("id") && (
              <>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email Address</Form.Label>
                <Form.Control 
                  name="email"
                  type="text"
                  placeholder="Email Address"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                  disabled={searchParams.get("id") ? true : false}
                  className={touched.email && errors.email ? "error" : null}
                />
                {touched.email && errors.email ? (
                  <div className="error-message">{errors.email}</div>
                ): null }

              </Form.Group>
              <Form.Group className="mb-3" controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control 
                name="firstName"
                type="text"
                placeholder="First Name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.firstName}
                disabled={searchParams.get("id") ? true : false}
                className={touched.firstName && errors.firstName ? "error" : null}
              />
              {touched.firstName && errors.firstName ? (
                <div className="error-message">{errors.firstName}</div>
              ): null}
            </Form.Group>
              <Form.Group className="mb-3" controlId="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control 
                name="lastName"
                type="text"
                placeholder="Last Name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.lastName}
                disabled={searchParams.get("id") ? true : false}
                className={touched.lastName && errors.lastName ? "error" : null}
              />
              {touched.lastName && errors.lastName ? (
                <div className="error-message">{errors.lastName}</div>
              ): null}
            </Form.Group>
         
            </>
          )}
          
              <Form.Group className="mb-3" controlId="street1">
                <Form.Label>Street</Form.Label>
                <Form.Control 
                  name="street1"
                  type="text"
                  placeholder="Street"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.street1}
                  className={touched.street1 && errors.street1 ? "error" : null}
                />
                {touched.street1 && errors.street1 ? (
                  <div className="error-message">{errors.street1}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="street2">
                <Form.Label>Apt/Suite Number</Form.Label>
                <Form.Control 
                  name="street2"
                  type="text"
                  placeholder="Apt/Suite Number"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.street2}
                  className={touched.street2 && errors.street2 ? "error" : null}
                />
                {touched.street2 && errors.street2 ? (
                  <div className="error-message">{errors.street2}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="city">
                <Form.Label>City</Form.Label>
                <Form.Control 
                  name="city"
                  type="text"
                  placeholder="City"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.city}
                  className={touched.city && errors.city ? "error" : null}
                />
                {touched.city && errors.city ? (
                  <div className="error-message">{errors.city}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="state">
                <Form.Label>State</Form.Label>
                <Form.Select
                  name="state"
                  value={values.state}
                  className={touched.state && errors.state ? "error" : null}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  >
                  <option value="">Select a State</option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </Form.Select>
                {touched.state && errors.state ? (
                  <div className="error-message">{errors.state}</div>
                ): null}
              </Form.Group>

              <Form.Group className="mb-3" controlId="zip">
                <Form.Label>Zip Code</Form.Label>
                <Form.Control 
                  name="zip"
                  type="text"
                  placeholder="Zip Code"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.zip}
                  className={touched.zip && errors.zip ? "error" : null}
                />
                {touched.zip && errors.zip ? (
                  <div className="error-message">{errors.zip}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control 
                  name="password"
                  type="password"
                  placeholder="Password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                  className={touched.password && errors.password ? "error" : null}
                />
                {touched.password && errors.password ? (
                  <div className="error-message">{errors.password}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="passwordConfirmation">
                <Form.Label>Password Confirmation</Form.Label>
                <Form.Control 
                  name="passwordConfirmation"
                  type="password"
                  placeholder="Password Confirmation"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.passwordConfirmation}
                  className={touched.passwordConfirmation && errors.passwordConfirmation ? "error" : null}
                />
                {touched.passwordConfirmation && errors.passwordConfirmation ? (
                  <div className="error-message">{errors.passwordConfirmation}</div>
                ): null}
              </Form.Group>

                <Button variant="primary" onClick={handleSubmit} type="submit" disabled={isSubmitting}>
                  Register
                </Button>
            </Form>  
      )}
    </Formik>
    </div>
        )}

    </div>
  );
};
export default Register;